// Landing page shown when the Mini App URL is visited in a regular browser
// (no Telegram initData). Functions as a marketing page that routes users
// to the bot. Same shape as the tarot Landing — astrology copy, 10 langs.

const COPY: Record<string, {
  badge: string;
  title: string;
  subtitle: string;
  body: string;
  feature1: string;
  feature2: string;
  feature3: string;
  priceHeader: string;
  priceNatal: string;
  priceCompat: string;
  priceYear: string;
  cta: string;
  secondary: string;
}> = {
  pl: {
    badge: 'Codzienna astrologia w Telegramie',
    title: 'Twój horoskop i karta urodzeniowa',
    subtitle: 'Matematyka astrologiczna · 10 języków · bez AI, bez reklam.',
    body: 'Każdego ranka o 8:00 dostajesz horoskop na dziś. Oblicz swoją kartę urodzeniową — pozycje planet, domy (Placidus), aspekty — wszystko z precyzją arcmin.',
    feature1: 'astronomy-engine (MIT) · ~1 arcmin dokładności',
    feature2: 'Codzienny push o 8:00 · PL · EN · RU · ES · PT · ID · FA · AR · HI · UK',
    feature3: 'Płatności Telegram Stars · natal chart, kompatybilność, roczna prognoza',
    priceHeader: 'Cennik (Stars)',
    priceNatal: 'Karta urodzeniowa (pełna)',
    priceCompat: 'Kompatybilność z partnerem',
    priceYear: 'Rok do przodu',
    cta: 'Otwórz w Telegramie',
    secondary: 'Bot · @yourastrologydailybot',
  },
  en: {
    badge: 'Daily astrology inside Telegram',
    title: 'Your horoscope and natal chart',
    subtitle: 'Real astrology math · 10 languages · no AI, no ads.',
    body: 'Every morning at 8:00 you get today\'s horoscope. Compute your natal chart — planet positions, Placidus houses, aspects — all at arc-minute precision.',
    feature1: 'astronomy-engine (MIT) · ~1 arcmin accuracy',
    feature2: 'Daily push at 8:00 · EN · PL · RU · ES · PT · ID · FA · AR · HI · UK',
    feature3: 'Telegram Stars payments · natal chart, compatibility, year ahead',
    priceHeader: 'Pricing (Stars)',
    priceNatal: 'Full natal chart',
    priceCompat: 'Compatibility with partner',
    priceYear: 'Year ahead reading',
    cta: 'Open in Telegram',
    secondary: 'Bot · @yourastrologydailybot',
  },
  ru: {
    badge: 'Ежедневная астрология в Telegram',
    title: 'Ваш гороскоп и натальная карта',
    subtitle: 'Настоящая астрологическая математика · 10 языков · без AI, без рекламы.',
    body: 'Каждое утро в 8:00 вы получаете гороскоп на сегодня. Рассчитайте натальную карту — положения планет, дома Плацида, аспекты — с точностью до минуты дуги.',
    feature1: 'astronomy-engine (MIT) · точность ~1 arcmin',
    feature2: 'Ежедневная рассылка в 8:00 · RU · EN · PL · ES · PT · ID · FA · AR · HI · UK',
    feature3: 'Оплата Telegram Stars · натальная карта, совместимость, прогноз на год',
    priceHeader: 'Цены (Stars)',
    priceNatal: 'Полная натальная карта',
    priceCompat: 'Совместимость с партнёром',
    priceYear: 'Прогноз на год',
    cta: 'Открыть в Telegram',
    secondary: 'Бот · @yourastrologydailybot',
  },
  es: {
    badge: 'Astrología diaria dentro de Telegram',
    title: 'Tu horóscopo y carta natal',
    subtitle: 'Matemática astrológica real · 10 idiomas · sin IA, sin anuncios.',
    body: 'Cada mañana a las 8:00 recibes el horóscopo del día. Calcula tu carta natal — posiciones planetarias, casas Placidus, aspectos — con precisión de minuto de arco.',
    feature1: 'astronomy-engine (MIT) · precisión ~1 arcmin',
    feature2: 'Envío diario a las 8:00 · ES · EN · PL · RU · PT · ID · FA · AR · HI · UK',
    feature3: 'Pagos Telegram Stars · carta natal, compatibilidad, año por delante',
    priceHeader: 'Precios (Stars)',
    priceNatal: 'Carta natal completa',
    priceCompat: 'Compatibilidad con pareja',
    priceYear: 'Año por delante',
    cta: 'Abrir en Telegram',
    secondary: 'Bot · @yourastrologydailybot',
  },
  pt: {
    badge: 'Astrologia diária dentro do Telegram',
    title: 'Seu horóscopo e mapa natal',
    subtitle: 'Matemática astrológica real · 10 idiomas · sem IA, sem anúncios.',
    body: 'Toda manhã às 8:00 você recebe o horóscopo do dia. Calcule seu mapa natal — posições planetárias, casas Placidus, aspectos — com precisão de minuto de arco.',
    feature1: 'astronomy-engine (MIT) · ~1 arcmin de precisão',
    feature2: 'Envio diário às 8:00 · PT · EN · PL · RU · ES · ID · FA · AR · HI · UK',
    feature3: 'Pagamentos Telegram Stars · mapa natal, compatibilidade, ano à frente',
    priceHeader: 'Preços (Stars)',
    priceNatal: 'Mapa natal completo',
    priceCompat: 'Compatibilidade com parceiro',
    priceYear: 'Ano à frente',
    cta: 'Abrir no Telegram',
    secondary: 'Bot · @yourastrologydailybot',
  },
  id: {
    badge: 'Astrologi harian di Telegram',
    title: 'Horoskop dan peta natal Anda',
    subtitle: 'Matematika astrologi nyata · 10 bahasa · tanpa AI, tanpa iklan.',
    body: 'Setiap pagi pukul 08:00 Anda menerima horoskop hari ini. Hitung peta natal Anda — posisi planet, rumah Placidus, aspek — dengan presisi arcmin.',
    feature1: 'astronomy-engine (MIT) · presisi ~1 arcmin',
    feature2: 'Kiriman harian pukul 08:00 · ID · EN · PL · RU · ES · PT · FA · AR · HI · UK',
    feature3: 'Pembayaran Telegram Stars · peta natal, kecocokan, prakiraan tahunan',
    priceHeader: 'Harga (Stars)',
    priceNatal: 'Peta natal lengkap',
    priceCompat: 'Kecocokan dengan pasangan',
    priceYear: 'Prakiraan tahunan',
    cta: 'Buka di Telegram',
    secondary: 'Bot · @yourastrologydailybot',
  },
  fa: {
    badge: 'طالع‌بینی روزانه در تلگرام',
    title: 'طالع روزانه و نقشه تولد شما',
    subtitle: 'ریاضیات نجومی واقعی · ۱۰ زبان · بدون AI، بدون تبلیغ.',
    body: 'هر صبح ساعت ۸:۰۰ طالع امروز را دریافت می‌کنید. نقشه تولد خود را محاسبه کنید — موقعیت سیارات، خانه‌های پلاسیدوس، جنبه‌ها — با دقت دقیقه قوسی.',
    feature1: 'astronomy-engine (MIT) · دقت حدود ۱ arcmin',
    feature2: 'ارسال روزانه ساعت ۸:۰۰ · FA · EN · PL · RU · ES · PT · ID · AR · HI · UK',
    feature3: 'پرداخت Telegram Stars · نقشه تولد، سازگاری، پیش‌بینی سال',
    priceHeader: 'قیمت (Stars)',
    priceNatal: 'نقشه تولد کامل',
    priceCompat: 'سازگاری با شریک',
    priceYear: 'پیش‌بینی یک‌ساله',
    cta: 'باز کردن در تلگرام',
    secondary: 'Bot · @yourastrologydailybot',
  },
  ar: {
    badge: 'تنجيم يومي داخل تلغرام',
    title: 'طالعك وخريطتك الفلكية',
    subtitle: 'رياضيات تنجيمية حقيقية · ١٠ لغات · بدون AI، بدون إعلانات.',
    body: 'كل صباح في الساعة ٨:٠٠ تحصل على برج اليوم. احسب خريطتك الفلكية — مواقع الكواكب، بيوت بلاسيدوس، الجوانب — بدقة دقيقة قوسية.',
    feature1: 'astronomy-engine (MIT) · دقة ~1 arcmin',
    feature2: 'إرسال يومي في ٨:٠٠ · AR · EN · PL · RU · ES · PT · ID · FA · HI · UK',
    feature3: 'دفع Telegram Stars · خريطة فلكية، توافق، قراءة سنوية',
    priceHeader: 'الأسعار (Stars)',
    priceNatal: 'الخريطة الفلكية الكاملة',
    priceCompat: 'التوافق مع شريك',
    priceYear: 'قراءة لمدة عام',
    cta: 'افتح في تلغرام',
    secondary: 'Bot · @yourastrologydailybot',
  },
  hi: {
    badge: 'Telegram में दैनिक ज्योतिष',
    title: 'आपका राशिफल और जन्म कुंडली',
    subtitle: 'वास्तविक ज्योतिषीय गणित · 10 भाषाएँ · बिना AI, बिना विज्ञापन।',
    body: 'हर सुबह 8:00 बजे आज का राशिफल मिलता है। अपनी जन्म कुंडली बनाएं — ग्रह स्थिति, प्लेसीडस भाव, दृष्टि — आर्कमिनट परिशुद्धता के साथ।',
    feature1: 'astronomy-engine (MIT) · ~1 arcmin परिशुद्धता',
    feature2: 'दैनिक पुश 8:00 · HI · EN · PL · RU · ES · PT · ID · FA · AR · UK',
    feature3: 'Telegram Stars भुगतान · जन्म कुंडली, अनुकूलता, वार्षिक भविष्यवाणी',
    priceHeader: 'क़ीमत (Stars)',
    priceNatal: 'पूर्ण जन्म कुंडली',
    priceCompat: 'साथी के साथ अनुकूलता',
    priceYear: 'साल की भविष्यवाणी',
    cta: 'Telegram में खोलें',
    secondary: 'Bot · @yourastrologydailybot',
  },
  uk: {
    badge: 'Щоденна астрологія в Telegram',
    title: 'Ваш гороскоп і натальна карта',
    subtitle: 'Справжня астрологічна математика · 10 мов · без AI, без реклами.',
    body: 'Щоранку о 8:00 ви отримуєте гороскоп на сьогодні. Розрахуйте натальну карту — положення планет, будинки Плацида, аспекти — з точністю до хвилини дуги.',
    feature1: 'astronomy-engine (MIT) · точність ~1 arcmin',
    feature2: 'Щоденна розсилка о 8:00 · UK · EN · PL · RU · ES · PT · ID · FA · AR · HI',
    feature3: 'Оплата Telegram Stars · натальна карта, сумісність, прогноз на рік',
    priceHeader: 'Ціни (Stars)',
    priceNatal: 'Повна натальна карта',
    priceCompat: 'Сумісність з партнером',
    priceYear: 'Прогноз на рік',
    cta: 'Відкрити в Telegram',
    secondary: 'Бот · @yourastrologydailybot',
  },
  tr: {
    badge: 'Telegram’da günlük astroloji',
    title: 'Günlük yorumunuz ve doğum haritanız',
    subtitle: 'Gerçek astroloji matematiği · 10 dil · AI yok, reklam yok.',
    body: 'Her sabah 08:00’de günün yorumunu alırsınız. Doğum haritanızı hesaplayın — gezegen konumları, Placidus evleri, açılar — yay-dakika hassasiyetinde.',
    feature1: 'astronomy-engine (MIT) · ~1 arcmin hassasiyet',
    feature2: 'Günlük gönderim 08:00 · TR · EN · PL · RU · ES · PT · ID · FA · AR · HI · UK',
    feature3: 'Telegram Stars ödemeleri · doğum haritası, uyum, yıllık okuma',
    priceHeader: 'Fiyatlar (Stars)',
    priceNatal: 'Tam doğum haritası',
    priceCompat: 'Partner uyumu',
    priceYear: 'Yıllık okuma',
    cta: 'Telegram’da aç',
    secondary: 'Bot · @yourastrologydailybot',
  },
};

interface Props {
  lang: string;
  botUsername: string;
}

export function Landing({ lang, botUsername }: Props) {
  const c = COPY[lang] ?? COPY.en!;
  const botLink = `https://t.me/${botUsername}`;

  return (
    <div className="landing">
      <section className="landing-hero">
        <div className="landing-hero-copy">
          <div className="landing-badge">{c.badge}</div>
          <h1 className="landing-title">{c.title}</h1>
          <p className="landing-subtitle">{c.subtitle}</p>
          <p className="landing-body">{c.body}</p>
          <a className="landing-cta" href={botLink}>
            {c.cta}
          </a>
          <div className="landing-secondary">
            <a href={botLink}>{c.secondary}</a>
          </div>
        </div>
        <div className="landing-hero-visual" aria-hidden>
          <svg viewBox="0 0 200 200" width="180" height="180">
            <defs>
              <radialGradient id="g" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#d9b35b" stopOpacity="0.25" />
                <stop offset="100%" stopColor="#d9b35b" stopOpacity="0" />
              </radialGradient>
            </defs>
            <circle cx="100" cy="100" r="95" fill="url(#g)" />
            <circle cx="100" cy="100" r="70" fill="none" stroke="rgba(217,179,91,0.55)" />
            <circle cx="100" cy="100" r="50" fill="none" stroke="rgba(217,179,91,0.35)" />
            {/* 12 signs at 30° ticks */}
            {Array.from({ length: 12 }).map((_, i) => {
              const a = (i * 30 - 90) * (Math.PI / 180);
              const x1 = 100 + 70 * Math.cos(a);
              const y1 = 100 + 70 * Math.sin(a);
              const x2 = 100 + 95 * Math.cos(a);
              const y2 = 100 + 95 * Math.sin(a);
              return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="rgba(255,255,255,0.35)" strokeWidth={0.8} />;
            })}
            {/* Sign glyphs */}
            {['♈','♉','♊','♋','♌','♍','♎','♏','♐','♑','♒','♓'].map((g, i) => {
              const a = (i * 30 - 75) * (Math.PI / 180);
              const x = 100 + 82 * Math.cos(a);
              const y = 100 + 82 * Math.sin(a);
              return (
                <text key={i} x={x} y={y} fontSize="10" fill="#d9b35b" textAnchor="middle" dominantBaseline="central">
                  {g}
                </text>
              );
            })}
            <text x="100" y="100" textAnchor="middle" dominantBaseline="central" fontSize="24" fill="#f1eadb">
              ☉
            </text>
          </svg>
        </div>
      </section>

      <section className="landing-features">
        <div className="landing-feature">✦ {c.feature1}</div>
        <div className="landing-feature">✦ {c.feature2}</div>
        <div className="landing-feature">✦ {c.feature3}</div>
      </section>

      <section className="landing-prices">
        <h2>{c.priceHeader}</h2>
        <ul>
          <li><span>💞 {priceRow(lang, 'love')}</span><span>30 ⭐</span></li>
          <li><span>✨ {priceRow(lang, 'extended')}</span><span>50 ⭐</span></li>
          <li><span>🌙 {priceRow(lang, 'moon')}</span><span>79 ⭐</span></li>
          <li><span>🗓 {priceRow(lang, 'weekly')}</span><span>99 ⭐</span></li>
          <li><span>💑 {c.priceCompat}</span><span>199 ⭐</span></li>
          <li><span>🪐 {c.priceNatal}</span><span>299 ⭐</span></li>
          <li><span>🗝 {c.priceYear}</span><span>499 ⭐</span></li>
          <li><span>⭐️ {priceRow(lang, 'premium')}</span><span>499 ⭐ / 30d</span></li>
        </ul>
      </section>

      <section className="landing-footer">
        <a className="landing-cta landing-cta-small" href={botLink}>{c.cta}</a>
      </section>
    </div>
  );
}

const EXTRA_PRICE_LABELS: Record<string, Record<string, string>> = {
  pl: { love: 'Horoskop miłosny (dziś)', extended: 'Rozszerzony horoskop (dziś)', moon: 'Rytuał Księżyca', weekly: 'Mapa tygodnia', premium: 'Premium (wszystko)' },
  en: { love: "Today's love reading", extended: 'Extended daily reading', moon: 'Moon ritual', weekly: 'Week ahead', premium: 'Premium (everything)' },
  ru: { love: 'Любовный гороскоп (сегодня)', extended: 'Расширенный гороскоп', moon: 'Ритуал Луны', weekly: 'Карта недели', premium: 'Premium (всё)' },
  es: { love: 'Lectura amorosa (hoy)', extended: 'Horóscopo extendido', moon: 'Ritual lunar', weekly: 'Semana entera', premium: 'Premium (todo)' },
  pt: { love: 'Leitura do amor (hoje)', extended: 'Horóscopo estendido', moon: 'Ritual da Lua', weekly: 'Mapa da semana', premium: 'Premium (tudo)' },
  id: { love: 'Ramalan cinta (hari ini)', extended: 'Ramalan diperluas', moon: 'Ritual Bulan', weekly: 'Peta minggu', premium: 'Premium (semua)' },
  fa: { love: 'طالع عشق (امروز)', extended: 'طالع گسترده', moon: 'آیین ماه', weekly: 'نقشه هفته', premium: 'Premium (همه چیز)' },
  ar: { love: 'قراءة الحب (اليوم)', extended: 'قراءة موسعة', moon: 'طقس القمر', weekly: 'خريطة الأسبوع', premium: 'Premium (كل شيء)' },
  hi: { love: 'प्रेम राशिफल (आज)', extended: 'विस्तृत राशिफल', moon: 'चंद्र अनुष्ठान', weekly: 'सप्ताह की मानचित्र', premium: 'Premium (सब कुछ)' },
  uk: { love: 'Любовний гороскоп (сьогодні)', extended: 'Розширений гороскоп', moon: 'Ритуал Місяця', weekly: 'Карта тижня', premium: 'Premium (все)' },
  tr: { love: 'Aşk yorumu (bugün)', extended: 'Genişletilmiş yorum', moon: 'Ay ritüeli', weekly: 'Hafta haritası', premium: 'Premium (hepsi)' },
};

function priceRow(lang: string, key: string): string {
  return EXTRA_PRICE_LABELS[lang]?.[key] ?? EXTRA_PRICE_LABELS.en![key]!;
}
